<template>
  <!-- <div></div> -->
  <div class="sidebar-header" >
    <div class="wise-text-shadow" style="text-align:left;">
      <p style="margin-top:-50px;margin-bottom:5px;">
        <span class="wise-header-36">
          DMC
        </span>
        <span class="wise-header-36" style="color:#315383;">
          Media
        </span>
      </p>
      <!-- <p class="wise-margin-bottom-0">
        DMC Media
      </p> -->
      <p style="font-size:11px;padding-bottom:10px;">
        Integrated Advertising Effect Estimator
      </p>
    </div>
    <div style="color:black">
      <div id="reachwiseprofile">
      <b-card border-variant="primary" class="wise-margin-bottom-0">
        <b-row>
          <b-col md="3" id="img_src_col">
            <img :src="userInfo.img_name" height="50" width="50" class="img-avatar">
          </b-col>
          <b-col md="9" style="text-align:left;">
            <p class="wise-margin-bottom-0"><span style="font-size:10px">| {{userInfo.company}}</span></p>
            <p class="wise-margin-bottom-0" style="font-size:14px;"><b>{{userInfo.user_name}}</b></p>
          </b-col>
        </b-row>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="primary" @click="asideToggle"><i class="fa fa-history fa-lg"></i> </b-button>
          <!-- <b-button type="submit" size="sm" variant="primary" ><i class="fa fa-info-circle fa-lg"></i> </b-button> -->
          <b-button type="reset" size="sm" variant="primary" @click="logoutSubmit()"><i class="fa fa-sign-out fa-lg"></i></b-button>
        </div>
        <a href="/" style="display:none" id="redirectLoginPage">Visit REACH</a>
      </b-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sidebar-header',
  data() {
    return {
      userInfo:{},
    }
  },
  mounted: function() {
    this.userInfo = this.$session.get('userInfo');
    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    // console.log(this.userInfo );

    // var param = "?username=" + this.userInfo.username;
    // this.$http.get('/select/userImg' + param)
    // .then((result) => {
    //   console.log('성공? !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    //   console.log(result);

      // var image = new Image();
      // const url = window.URL.createObjectURL(new Blob([result.data]));
      // image.src = window.URL.createObjectURL(new Blob([this.userInfo.user_img]));
      // // console.log(image);
      // document.getElementById('img_src_col').appendChild(image);
      // var blob = new Blob([result.data]);
      // var image = new Image();
      // image.src = window.URL.createObjectURL(blob);
      // document.getElementById('img_src_col').appendChild(image);

    // })
    // var image = new Image();
    // const url = window.URL.createObjectURL(new Blob([result.data]));
    // image.src = window.URL.createObjectURL(new Blob([this.userInfo.user_img]));
    // console.log(image);
    // document.getElementById('img_src_col').appendChild(image);
  }
  ,
  methods: {
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden');
      window.dispatchEvent(new Event('resize')); // 강제로 resize 이벤트 발생시키기
    },
    logoutSubmit(){
      this.$store.dispatch('LOGOUT');
      // this.$router.push("/pages/login")
      document.getElementById("redirectLoginPage").click();
      // 로그아웃 하면서 세션 초기화 등등의 기능을 추가한다.
    }
  }
}
</script>
<style scoped>
#reachwiseprofile .card-body{
  padding:0.6rem !important;
}#reachwiseprofile .card-footer{
  padding:0.45rem 1.25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarHeader.vue